"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.youtubeCaptions = exports.youtubeCaptionsResultSchema = exports.youtubeCaptionsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.youtubeCaptionsArgsSchema = zod_1.z.object({
    videoId: zod_1.z.string().describe('required: The YouTube video ID to fetch captions for'),
    emitMode: common_1.emitModeSchema
        .default('single')
        .describe('Emit mode for the tool. Default to "single".'),
});
// Result schema
exports.youtubeCaptionsResultSchema = zod_1.z.object({
    type: zod_1.z.string().describe('The type of the video (i.e., "video" or "shorts")'),
    url: zod_1.z.string().describe('The URL of the video'),
    timestamped_captions: zod_1.z
        .array(zod_1.z.object({
        text: zod_1.z.string().describe('The caption text'),
        startMs: zod_1.z.number().describe('The start time of the caption in milliseconds'),
        endMs: zod_1.z.number().describe('The end time of the caption in milliseconds'),
        startTimeText: zod_1.z.string().describe('The start time of the caption in text format'),
    }))
        .describe('Array of timestamped captions'),
    captions: zod_1.z.string().describe('The complete captions text without timestamps'),
});
// Tool definition
exports.youtubeCaptions = (0, common_1.createEmitModeToolMetadata)({
    id: 'youtubeCaptions',
    displayName: 'YouTube Captions',
    displayDescription: 'Fetch captions/transcript from a YouTube video',
    category: 'search',
    color: common_1.BRAND_COLORS.YOUTUBE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.YOUTUBE),
    icon: 'youtube',
    argsSchema: exports.youtubeCaptionsArgsSchema,
}, exports.youtubeCaptionsResultSchema);
